<div class="modal-header ">
    <!-- p-0 py-2 px-3 -->
    <!-- <h4 class="modal-title text-center" id="myCenterModalLabel">Forget Password</h4> -->
    <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button>
</div>
<div class="modal-body" >   
    <div class="row">
        <p class="hintlabel">Are you sure to logout?</p>

    </div>
    <div class=" row p-2">
        <div class="col-6">
            <button 
            class="btn btn-lg w-100 btncancel"
            type="submit"
           >Cancel</button>
        </div>
        <div class="col-6">
            <button 
            class="btn btn-lg w-100 btnForgetPassword"
            type="submit"
           >Yes,Log Out</button>
        </div>
       
        
    </div>
  
</div>